var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEye24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.38 12c-1-1.3-4.07-4.5-7.37-4.5S5.64 10.7 4.64 12c1 1.3 4.07 4.5 7.37 4.5 3.2 0 6.27-3.2 7.37-4.5zm-15.785-.277C4.446 10.608 7.863 6.5 12.011 6.5c4.15 0 7.552 4.11 8.397 5.224a.45.45 0 010 .552c-.846 1.114-4.248 5.224-8.397 5.224-4.148 0-7.565-4.108-8.416-5.223a.45.45 0 010-.554zM9.511 12a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm2.5-1.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye24);
export default __webpack_public_path__ + "static/media/icon-eye-24.9d19327a.svg";
export { ForwardRef as ReactComponent };